<app-toast></app-toast>
<div class="h-screen flex flex-col items-center p-5 mobile:p-2">
    <!-- Top bar-->
    <div class="w-full">
        <app-admin-topbar></app-admin-topbar>
    </div>

    <!-- Tab Navigation -->
    <div class="w-full">
        <app-admin-navigation [isActiveNumber]="0"></app-admin-navigation>
    </div>

    <div class="w-full h-auto border-[1px] border-border rounded-[20px] flex flex-col mt-2">
        <!-- Header text -->
        <div class="flex">
            <div class="flex flex-col gap-4 h-[60px] justify-between">
                <p class="text-primary font-semibold ml-4 mr-4 mt-4 mobile:text-sm">{{ 'admin.market_data'
                    | transloco }}
                </p>
                <div class="h-[2px] w-full bg-primary"></div>
            </div>
            <div class="h-[60px] flex flex-grow items-end justify-start mobile:hidden">
                <div class="h-[2px] w-full bg-border"></div>
            </div>
        </div>

        <div class="m-5 flex flex-wrap gap-2 justify-between items-center">
            <div>
                <p class="text-neutral-800">{{ 'admin.mannualy_edit' | transloco }}</p>
                <p class="text-neutral-800">{{ 'admin.click_edit' | transloco }}</p>
            </div>
            <div *ngIf="marketDataLoaded && marketDataLoadingError">
                <p class="text-error">{{ 'admin.market_data_error' | transloco }}</p>
            </div>
            <div class="flex flex-wrap gap-2" *ngIf="!marketDataLoaded">
                <p class="text-error">{{ 'admin.loading_market_data' | transloco }}</p>
                <span class="loading loading-dots loading-sm"></span>
            </div>
            <div *ngIf="marketDataLoaded && !marketDataLoadingError">

                <div class="w-[150px] h-[50px]" *ngIf="!editing">
                    <app-custom-button buttonText="{{ 'settings.button.edit' | transloco }}" [isDisabled]="false"
                        backgroundColor="bg-primary" textColor="text-white" borderColor="border:bg-primary"
                        hoverBackgroundColor="hover:bg-primary-1200" trailingIcon="assets/icons/settings/edit.svg"
                        (click)="editButtonClick()">
                    </app-custom-button>
                </div>
                <div class="flex flex-wrap gap-2" *ngIf="editing">
                    <div class="w-[150px] h-[50px]">
                        <app-custom-button buttonText="{{ 'shared.cancel' | transloco }}" [isDisabled]="false"
                            backgroundColor="bg-neutral" textColor="text-black" borderColor="border:bg-neutral"
                            hoverBackgroundColor="hover:bg-neutral-1200" hoverBorderColor="hover:border-neutral-1200"
                            (click)="cancelButtonClick()">
                        </app-custom-button>
                    </div>

                    <div class="w-[150px] h-[50px]">
                        <app-custom-button buttonText="{{ 'shared.save' | transloco }}" [isDisabled]="false"
                            backgroundColor="bg-secondary" textColor="text-black" borderColor="border:bg-secondary"
                            hoverBackgroundColor="hover:bg-secondary-1200"
                            hoverBorderColor="hover:border-secondary-1200" trailingIcon="assets/icons/upload.svg"
                            (click)="saveButtonClick()">
                        </app-custom-button>
                    </div>
                </div>

            </div>
        </div>

        <div class="flex flex-col gap-2 m-5 py-2">
            <h1 class="font-bold">{{ 'shared.energy' | transloco }}</h1>
            <!-- Row -->
            <div class="w-full flex flex-wrap gap-2 px-2">

                <div class="flex-[1] self-center min-w-[300px]">
                    <app-custom-number-input labelText="{{ 'admin.labels.dispatchingFactor' | transloco }}"
                        [inputId]="'dispatchingFactor'" [inputType]="'number'" [(inputValue)]="dispatchingFactorInput"
                        [errorMessage]="dispatchingFactorInputError"
                        placeholder="{{ 'admin.placeholders.dispatchingFactor' | transloco }}"
                        [isDisabled]="!editing"></app-custom-number-input>
                </div>

                <div class="flex-[1] self-center min-w-[300px] px-2">
                    <app-custom-number-input labelText="{{ 'admin.labels.marketCapacityPeak' | transloco }}"
                        [inputId]="'marketCapacityPeak'" [inputType]="'number'" [(inputValue)]="marketCapacityPeakInput"
                        [errorMessage]="marketCapacityPeakInputError"
                        placeholder="{{ 'admin.placeholders.marketCapacityPeak' | transloco }}"
                        [isDisabled]="!editing"></app-custom-number-input>
                </div>

                <div class="flex-[1] self-center min-w-[300px] px-2">
                    <app-custom-number-input labelText="{{ 'admin.labels.marketCapacityLow' | transloco }}"
                        [inputId]="'marketCapacityLow'" [inputType]="'number'" [(inputValue)]="marketCapacityLowInput"
                        [errorMessage]="marketCapacityLowInputError"
                        placeholder="{{ 'admin.placeholders.marketCapacityLow' | transloco }}"
                        [isDisabled]="!editing"></app-custom-number-input>
                </div>
            </div>

            <!-- Row -->
            <div class="w-full flex flex-wrap gap-2">
                <div class="flex-[1] self-center min-w-[300px] px-2">
                    <app-custom-number-input labelText="{{ 'admin.labels.transportationFactor1' | transloco }}"
                        [inputId]="'transportationFactor1'" [inputType]="'number'"
                        [(inputValue)]="transportationFactor1Input" [errorMessage]="transportationFactor1InputError"
                        placeholder="{{ 'admin.placeholders.transportationFactor1' | transloco }}"
                        [isDisabled]="!editing"></app-custom-number-input>
                </div>

                <div class="flex-[1] self-center min-w-[300px] px-2">
                    <app-custom-number-input labelText="{{ 'admin.labels.transportationFactor2' | transloco }}"
                        [inputId]="'transportationFactor2'" [inputType]="'number'"
                        [(inputValue)]="transportationFactor2Input" [errorMessage]="transportationFactor2InputError"
                        placeholder="{{ 'admin.placeholders.transportationFactor2' | transloco }}"
                        [isDisabled]="!editing"></app-custom-number-input>
                </div>

                <div class="flex-[1] self-center min-w-[300px] px-2">
                    <app-custom-number-input labelText="{{ 'admin.labels.systemCharges' | transloco }}"
                        [inputId]="'systemCharges'" [inputType]="'number'" [(inputValue)]="systemChargesInput"
                        [errorMessage]="systemChargesInputError"
                        placeholder="{{ 'admin.placeholders.systemCharges' | transloco }}"
                        [isDisabled]="!editing"></app-custom-number-input>
                </div>
            </div>

            <!-- Row -->
            <div class="w-full flex flex-wrap gap-2">
                <div class="flex-[1] self-center min-w-[300px] px-2">
                    <app-custom-number-input labelText="{{ 'admin.labels.taxRate1' | transloco }}"
                        [inputId]="'taxRate1'" [inputType]="'number'" [(inputValue)]="taxRate1Input"
                        [errorMessage]="taxRate1InputError"
                        placeholder="{{ 'admin.placeholders.taxRate1' | transloco }}"
                        [isDisabled]="!editing"></app-custom-number-input>
                </div>

                <div class="flex-[1] self-center min-w-[300px] px-2">
                    <app-custom-number-input labelText="{{ 'admin.labels.taxRate2' | transloco }}"
                        [inputId]="'taxRate2'" [inputType]="'number'" [(inputValue)]="taxRate2Input"
                        [errorMessage]="taxRate2InputError"
                        placeholder="{{ 'admin.placeholders.taxRate2' | transloco }}"
                        [isDisabled]="!editing"></app-custom-number-input>
                </div>
            </div>

            <!-- Second Form Data -->
            <h1 class="font-bold mt-2">{{ 'shared.gas' | transloco }}</h1>

            <!-- Row -->
            <div class="w-full flex flex-wrap gap-2">
                <div class="flex-[1] self-center min-w-[300px] px-2">
                    <app-custom-number-input labelText="{{ 'admin.labels.standardPCS' | transloco }}"
                        [inputId]="'standardPCS'" [inputType]="'number'" [(inputValue)]="standardPCSInput"
                        [errorMessage]="standardPCSInputError"
                        placeholder="{{ 'admin.placeholders.standardPCS' | transloco }}"
                        [isDisabled]="!editing"></app-custom-number-input>
                </div>

                <div class="flex-[1] self-center min-w-[300px] px-2">
                    <app-custom-number-input labelText="{{ 'admin.labels.gasMeterFee' | transloco }}"
                        [inputId]="'gasMeterFee'" [inputType]="'number'" [(inputValue)]="gasMeterFeeInput"
                        [errorMessage]="gasMeterFeeInputError"
                        placeholder="{{ 'admin.placeholders.gasMeterFee' | transloco }}"
                        [isDisabled]="!editing"></app-custom-number-input>
                </div>

                <div class="flex-[1] self-center min-w-[300px] px-2">
                    <app-custom-number-input labelText="{{ 'admin.labels.costEqualisationFee' | transloco }}"
                        [inputId]="'costEqualisationFee'" [inputType]="'number'"
                        [(inputValue)]="costEqualisationFeeInput" [errorMessage]="costEqualisationFeeInputError"
                        placeholder="{{ 'admin.placeholders.costEqualisationFee' | transloco }}"
                        [isDisabled]="!editing"></app-custom-number-input>
                </div>
            </div>

            <!-- Row -->
            <div class="w-full flex flex-wrap gap-2 mt-5">
                <div class="flex-[1] self-center min-w-[300px] px-2">
                    <app-custom-number-input labelText="{{ 'admin.labels.variableDistributionCosts1' | transloco }}"
                        [inputId]="'variableDistributionCost1'" [inputType]="'number'"
                        [(inputValue)]="variableDistributionCost1" [errorMessage]="variableDistributionCost1Error"
                        placeholder="{{ 'admin.placeholders.variableDistributionCosts1' | transloco }}"
                        [isDisabled]="!editing">
                    </app-custom-number-input>
                </div>

                <div class="flex-[1] self-center min-w-[300px] px-2">
                    <app-custom-number-input labelText="{{ 'admin.labels.variableDistributionCosts2' | transloco }}"
                        [inputId]="'variableDistributionCost2'" [inputType]="'number'"
                        [(inputValue)]="variableDistributionCost2" [errorMessage]="variableDistributionCost2Error"
                        placeholder="{{ 'admin.placeholders.variableDistributionCosts2' | transloco }}"
                        [isDisabled]="!editing">
                    </app-custom-number-input>
                </div>

                <div class="flex-[1] self-center min-w-[300px] px-2">
                    <app-custom-number-input labelText="{{ 'admin.labels.variableDistributionCosts3' | transloco }}"
                        [inputId]="'variableDistributionCost3'" [inputType]="'number'"
                        [(inputValue)]="variableDistributionCost3" [errorMessage]="variableDistributionCost3Error"
                        placeholder="{{ 'admin.placeholders.variableDistributionCosts3' | transloco }}"
                        [isDisabled]="!editing">
                    </app-custom-number-input>
                </div>
            </div>
            <!-- Row -->
            <div class="w-full flex flex-wrap gap-2">
                <div class="flex-[1] self-center min-w-[300px] px-2">
                    <app-custom-number-input labelText="{{ 'admin.labels.variableDistributionCosts4' | transloco }}"
                        [inputId]="'variableDistributionCost4'" [inputType]="'number'"
                        [(inputValue)]="variableDistributionCost4" [errorMessage]="variableDistributionCost4Error"
                        placeholder="{{ 'admin.placeholders.variableDistributionCosts4' | transloco }}"
                        [isDisabled]="!editing">
                    </app-custom-number-input>
                </div>

                <div class="flex-[1] self-center min-w-[300px] px-2">
                    <app-custom-number-input labelText="{{ 'admin.labels.variableDistributionCosts5' | transloco }}"
                        [inputId]="'variableDistributionCost5'" [inputType]="'number'"
                        [(inputValue)]="variableDistributionCost5" [errorMessage]="variableDistributionCost5Error"
                        placeholder="{{ 'admin.placeholders.variableDistributionCosts5' | transloco }}"
                        [isDisabled]="!editing">
                    </app-custom-number-input>
                </div>

                <div class="flex-[1] self-center min-w-[300px] px-2">
                    <app-custom-number-input labelText="{{ 'admin.labels.variableDistributionCosts6' | transloco }}"
                        [inputId]="'variableDistributionCost6'" [inputType]="'number'"
                        [(inputValue)]="variableDistributionCost6" [errorMessage]="variableDistributionCost6Error"
                        placeholder="{{ 'admin.placeholders.variableDistributionCosts6' | transloco }}"
                        [isDisabled]="!editing">
                    </app-custom-number-input>
                </div>
            </div>
            <!-- Row -->
            <div class="w-full flex flex-wrap gap-2">
                <div class="flex-[1] self-center min-w-[300px] px-2">
                    <app-custom-number-input labelText="{{ 'admin.labels.variableDistributionCosts7' | transloco }}"
                        [inputId]="'variableDistributionCost7'" [inputType]="'number'"
                        [(inputValue)]="variableDistributionCost7" [errorMessage]="variableDistributionCost7Error"
                        placeholder="{{ 'admin.placeholders.variableDistributionCosts7' | transloco }}"
                        [isDisabled]="!editing">
                    </app-custom-number-input>
                </div>

                <div class="flex-[1] self-center min-w-[300px] px-2">
                    <app-custom-number-input labelText="{{ 'admin.labels.variableDistributionCosts8' | transloco }}"
                        [inputId]="'variableDistributionCost8'" [inputType]="'number'"
                        [(inputValue)]="variableDistributionCost8" [errorMessage]="variableDistributionCost8Error"
                        placeholder="{{ 'admin.placeholders.variableDistributionCosts8' | transloco }}"
                        [isDisabled]="!editing">
                    </app-custom-number-input>
                </div>
            </div>

            <!-- Row -->
            <div class="w-full flex flex-wrap gap-2 mt-5">
                <div class="flex-[1] self-center min-w-[300px] px-2">
                    <app-custom-number-input labelText="{{ 'admin.labels.stateTaxRate' | transloco }}"
                        [inputId]="'stateTaxRate'" [inputType]="'number'" [(inputValue)]="stateTaxRateInput"
                        [errorMessage]="stateTaxRateInputError"
                        placeholder="{{ 'admin.placeholders.stateTaxRate' | transloco }}"
                        [isDisabled]="!editing"></app-custom-number-input>
                </div>

                <div class="flex-[1] self-center min-w-[300px] px-2">
                    <app-custom-number-input labelText="{{ 'admin.labels.regionTaxRate' | transloco }}"
                        [inputId]="'regionTaxRate'" [inputType]="'number'" [(inputValue)]="regionTaxRateInput"
                        [errorMessage]="regionTaxRateInputError"
                        placeholder="{{ 'admin.placeholders.regionTaxRate' | transloco }}"
                        [isDisabled]="!editing"></app-custom-number-input>
                </div>
            </div>

        </div>
    </div>
    <app-custom-footer></app-custom-footer>
</div>